import { Col, Switch, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import { useState } from 'react';

let searchTimeout;
const RenderTitleQueryCondition = ({
  isDragging,
  property,
  viewMode,
  handleConjunction,
}) => {
  const [value, setValue] = useState(property?.operation === 'AND');

  const debounceUpdateValue = (checked) => {
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      handleConjunction(property?.valuePath, checked);
    }, 300);
  };

  const handleUpdateValue = (checked) => {
    setValue(checked);
    debounceUpdateValue(checked);
  };

  return (
    <Col
      className={isDragging && 'switch-conjunction'}
      style={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 24,
        width: '100%',
        backgroundColor: isDragging && '#69c0ff',
      }}
    >
      <Switch
        disabled={Boolean(viewMode)}
        size='small'
        checkedChildren={
          <Typography.Text className='query-condition__switch-button-active'>
            AND
          </Typography.Text>
        }
        unCheckedChildren={
          <Typography.Text className='query-condition__switch-button-inactivate'>
            OR
          </Typography.Text>
        }
        checked={value}
        onClick={(checked) => {
          handleUpdateValue(checked);
        }}
        style={{
          width: 44,
          color: value ? '#fff' : 'rgba(0, 0, 0, 0.65)',
          background: value ? '#2684ff' : '#ccc',
          display: 'flex',
          flexShrink: '0',
        }}
      />
      <span
        style={{
          marginLeft: 5,
          fontWeight: 500,
          fontSize: 14,
          display: 'flex',
          width: '100%',
        }}
      >
        {isDragging ? (
          <div
            style={{
              width: '100%',
              paddingRight: 23,
              color: '#fff',
            }}
          >
            <PlusOutlined />
            <span>Add new property</span>
          </div>
        ) : (
          <span>Group Query Conditions</span>
        )}
      </span>
    </Col>
  );
};

export default RenderTitleQueryCondition;
